import { render } from "./App.vue?vue&type=template&id=1fd0d417&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1fd0d417&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1fd0d417"

export default script